import { Slot, SlotDirection, SlotSize } from "./types/layout";
/**
 * Remplace les noms de champs dans le template par la valeur dans l'enregistrement
 * @param template Chaine de template
 * @param context Objet contexte
 * @returns
 */
export var replaceVariables = function (template, context) {
    return template === null || template === void 0 ? void 0 : template.replace(/({([^{}]+)})/gm, function (match, pattern, field, offset, string) {
        return context[field] || "";
    });
};
/**
 * Compare widget components by order
 * @param {*} a
 * @param {*} b
 */
export var widgetSortOrderAsc = function (a, b) {
    var _a, _b;
    var first = ((_a = a.meta) === null || _a === void 0 ? void 0 : _a.order) !== undefined ? a.meta.order : 0;
    var second = ((_b = b.meta) === null || _b === void 0 ? void 0 : _b.order) !== undefined ? b.meta.order : 0;
    return first - second;
};
export function generateRandomColor() {
    var myRandomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
    return myRandomColor;
}
/*export function replaceMultiple(text: string, characters: string) {
  for (const [search, replacement] of Object.entries(characters)) {
    text = text.replaceAll(search, replacement);
  }
  return text;
}*/
export function replaceMultiple(dateTimeFormat, replacements) {
    return Object.keys(replacements).reduce(function (format, key) {
        return format.replace(new RegExp(key, "g"), replacements[key]);
    }, dateTimeFormat);
}
export function validateEmail(email) {
    if (email === "") {
        return true;
    }
    else {
        var result = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
        return result;
    }
}
export function initials(record) {
    var item = record || {};
    var name = item.name || "";
    var parts = name.split(" ");
    var initials = [];
    for (var i = 0; i < 2 && i < parts.length; i++) {
        var part = parts[i];
        initials.push(part.charAt(0) || "");
    }
    return initials.join("");
}
export function imagePath(image) {
    var value = (image === null || image === void 0 ? void 0 : image.data) || {};
    var original = value.original || "";
    var file = original.file || "";
    return file;
}
export function imageUrl(image) {
    var date = new Date();
    var time = date.getTime();
    return (process.env.REACT_APP_ETCRM_URL + "/" + imagePath(image) + "?v=" + time);
}
export function hasImage(image) {
    return imagePath(image);
}
export var slotDirection = function (slot) {
    return [
        Slot.MENU_WEST,
        Slot.MENU_EAST,
        Slot.DOCK_WEST,
        Slot.DOCK_EAST,
        Slot.PREVIEW_WEST,
        Slot.PREVIEW_EAST,
        Slot.DRAWER_WEST,
        Slot.DRAWER_EAST,
    ].includes(slot)
        ? SlotDirection.VERTICAL
        : SlotDirection.HORIZONTAL;
};
export var slotSize = function (slot) {
    return [
        Slot.HEADER_START,
        Slot.HEADER_CENTER,
        Slot.HEADER_END,
        Slot.MENU_NORTH,
        Slot.FOOTER_START,
        Slot.FOOTER_CENTER,
        Slot.FOOTER_END,
    ].includes(slot)
        ? SlotSize.SMALL
        : SlotSize.NORMAL;
};
/**
 * Include script URL to component
 * @param url
 */
var addIncludeScript = function (url) {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
    return function () {
        document.body.removeChild(script);
    };
};
export default addIncludeScript;
export var toKebabCase = function (str) {
    return str &&
        str
            .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
            .map(function (x) { return x.toLowerCase(); })
            .join("-");
};
export var toCamelCase = function (str) {
    var s = str &&
        str
            .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
            .map(function (x) { return x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase(); })
            .join("");
    return s.slice(0, 1).toLowerCase() + s.slice(1);
};
export var isEmpty = function (value) {
    return (value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0));
};
export var defaultValues = {
    mt: "1em",
    mr: "1em",
    mb: "1em",
    ml: "1em",
    pt: "0.25em",
    pb: "0.25em",
    pl: "1em",
    pr: "1em",
};
export var borderButtonDefault = "4px";
export var borderTabsDefault = "8px";
export var borderSubpanelDefault = "16px";
export var borderTitleDetailsDefault = "16px";
export var borderFicheDetailsDefault = "16px";
export var spacingDefaultValues = {
    spacing_element_top: "0px",
    spacing_element_bottom: "0px",
    spacing_element_left: "2px",
    spacing_element_right: "2px",
};
export var borderRadiusTopDefaultValues = {
    topLeft: "16px",
    topRight: "16px",
    bottomLeft: "0px",
    bottomRight: "0px",
};
export var borderRadiusBottomDefaultValues = {
    topLeft: "0px",
    topRight: "0px",
    bottomLeft: "16px",
    bottomRight: "16px",
};
export var borderRadiusDefaultValues = {
    topLeft: "16px",
    topRight: "16px",
    bottomLeft: "16px",
    bottomRight: "16px",
};
export var borderRadius0DefaultValues = {
    topLeft: "0px",
    topRight: "0px",
    bottomLeft: "0px",
    bottomRight: "0px",
};
export var borderColorTabSelectedClass = "border-b-[var(--colors-tab-borderColor-bottom)] border-t-[var(--colors-tab-borderColor-top)] border-l-[var(--colors-tab-borderColor-left)] border-r-[var(--colors-tab-borderColor-right)]";
export var spacingOngletsClass = "ml-[var(--spacing-element-tabs-left)] mr-[var(--spacing-element-tabs-right)] mb-[var(--spacing-element-tabs-bottom)] mt-[var(--spacing-element-tabs-top)]";
export var borderRadiusTabSelectedClass = "rounded-tl-[var(--border-tab-selected-topLeft)] rounded-tr-[var(--border-tab-selected-topRight)] rounded-bl-[var(--border-tab-selected-bottomLeft)] rounded-br-[var(--border-tab-selected-bottomRight)]";
export var borderRadiusTabClass = "rounded-tl-[var(--border-tab-topLeft)] rounded-tr-[var(--border-tab-topRight)] rounded-bl-[var(--border-tab-bottomLeft)] rounded-br-[var(--border-tab-bottomRight)]";
export var borderRadiusTabHoverClass = "hover:rounded-tl-[var(--border-tab-hovered-topLeft)] hover:rounded-tr-[var(--border-tab-hovered-topRight)] hover:rounded-bl-[var(--border-tab-hovered-bottomLeft)] hover:rounded-br-[var(--border-tab-hovered-bottomRight)]";
export var borderRadiusSubpanel = "rounded-tl-[var(--border-subpanel-topLeft)] rounded-tr-[var(--border-subpanel-topRight)] rounded-bl-[var(--border-subpanel-bottomLeft)] rounded-br-[var(--border-subpanel-bottomRight)]";
export var THEME_RUNTIME_CONFIG_COLOR_DARK = {
    colors: {
        /** CONTENT / TEXT */
        label: { intensity: "50", keyDefinition: "label", fixedKey: "label" },
        content: {
            intensity: "950",
            keyDefinition: "content",
            fixedKey: "content",
        },
        text: { intensity: "200", keyDefinition: "", fixedKey: "neutral" },
        facelift: { intensity: "950", keyDefinition: "facelift_text" },
        "facelift-circle": { intensity: "700", keyDefinition: "facelift_text" },
        subpanel: { intensity: "50", keyDefinition: "sub_panel" },
        "subpanel-bg": { intensity: "800", keyDefinition: "sub_panel" },
        tabs: { intensity: "400", keyDefinition: "tabs" },
        tab: { intensity: "100", keyDefinition: "tab" },
        "tab-selected": { intensity: "700", keyDefinition: "tab_selected" },
        "tab-hovered": { intensity: "200", keyDefinition: "tab_hovered" },
        "tab-text-survol": { intensity: "900", keyDefinition: "tab_hovered" },
        "tab-text": { intensity: "700", keyDefinition: "tab" },
        /**BORDER COLOR */
        "tab-borderColor-top": {
            intensity: "700",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_top",
        },
        "tab-borderColor-bottom": {
            intensity: "700",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_bottom",
        },
        "tab-borderColor-left": {
            intensity: "700",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_left",
        },
        "tab-borderColor-right": {
            intensity: "700",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_right",
        },
        /*UNDERLINE COLOR*/
        underline: { intensity: "400", keyDefinition: "underline_color" },
        "underline-selected": {
            intensity: "800",
            keyDefinition: "underline_color",
        },
        /** HEADER / FOOTER */
        header: { intensity: "800", keyDefinition: "header" },
        "header-logo": { intensity: "800", keyDefinition: "header_logo" },
        "header-user": { intensity: "800", keyDefinition: "header_user" },
        footer: { intensity: "800", keyDefinition: "footer" },
        "footer-logo": { intensity: "800", keyDefinition: "footer_logo" },
        "footer-settings": { intensity: "800", keyDefinition: "footer_logo" },
        /** MAIN BACKGROUND */
        "main-bg": { intensity: "900", keyDefinition: "main" },
        /** WIDGETS */
        widget: { intensity: "700", keyDefinition: "widget" },
        "widget-hover": { intensity: "600", keyDefinition: "widget" },
        /** BODY */
        body: { intensity: "300", keyDefinition: "body" },
        /** MENUS – WEST */
        "menu-west": { intensity: "800", keyDefinition: "" },
        "menu-west--hover": { intensity: "800", keyDefinition: "" },
        "menu-west--open": { intensity: "800", keyDefinition: "" },
        "menu-west--hover-bg": { intensity: "700", keyDefinition: "" },
        "menu-west--open-bg": { intensity: "800", keyDefinition: "" },
        "menu-west-bg": { intensity: "900", keyDefinition: "menu_west" },
        /** MENUS – EAST */
        "menu-east": { intensity: "500", keyDefinition: "" },
        "menu-east--open": { intensity: "900", keyDefinition: "" },
        "menu-east-bg": { intensity: "900", keyDefinition: "menu_east" },
        "menu-east--hover": { intensity: "800", keyDefinition: "" },
        "menu-east--hover-bg": { intensity: "800", keyDefinition: "" },
        "menu-east--open-bg": { intensity: "900", keyDefinition: "" },
        /** MENUS – NORTH */
        "menu-north": { intensity: "500", keyDefinition: "" },
        "menu-north--hover": { intensity: "900", keyDefinition: "" },
        "menu-north--open": { intensity: "900", keyDefinition: "" },
        "menu-north-bg": { intensity: "900", keyDefinition: "menu_north" },
        "menu-north--hover-bg": { intensity: "900", keyDefinition: "" },
        "menu-north--open-bg": { intensity: "800", keyDefinition: "" },
        /** MENUS – SOUTH */
        "menu-south": { intensity: "700", keyDefinition: "" },
        "menu-south--hover": { intensity: "800", keyDefinition: "" },
        "menu-south--open": { intensity: "900", keyDefinition: "" },
        "menu-south-bg": { intensity: "800", keyDefinition: "menu_south" },
        "menu-south--hover-bg": { intensity: "700", keyDefinition: "" },
        "menu-south--open-bg": { intensity: "600", keyDefinition: "" },
        /** DOCK – NORTH */
        "dock-north": { intensity: "500", keyDefinition: "" },
        "dock-north--hover": { intensity: "500", keyDefinition: "" },
        "dock-north--open": { intensity: "900", keyDefinition: "" },
        "dock-north-bg": { intensity: "900", keyDefinition: "dock_north" },
        "dock-north--hover-bg": { intensity: "700", keyDefinition: "" },
        "dock-north--open-bg": { intensity: "900", keyDefinition: "" },
        /** DOCK – SOUTH */
        "dock-south": { intensity: "100", keyDefinition: "" },
        "dock-south--hover": { intensity: "500", keyDefinition: "" },
        "dock-south--open": { intensity: "900", keyDefinition: "" },
        "dock-south-bg": { intensity: "900", keyDefinition: "dock_south" },
        "dock-south--hover-bg": { intensity: "700", keyDefinition: "" },
        "dock-south--open-bg": { intensity: "900", keyDefinition: "" },
        /** DOCK – WEST */
        "dock-west": { intensity: "500", keyDefinition: "" },
        "dock-west--hover": { intensity: "500", keyDefinition: "" },
        "dock-west--open": { intensity: "500", keyDefinition: "" },
        "dock-west-bg": { intensity: "900", keyDefinition: "dock_west" },
        "dock-west--hover-bg": { intensity: "700", keyDefinition: "" },
        "dock-west--open-bg": { intensity: "900", keyDefinition: "" },
        /** DOCK – EAST */
        "dock-east": { intensity: "500", keyDefinition: "" },
        "dock-east--hover": { intensity: "100", keyDefinition: "" },
        "dock-east--open": { intensity: "900", keyDefinition: "" },
        "dock-east-bg": { intensity: "900", keyDefinition: "dock_east" },
        "dock-east--hover-bg": { intensity: "700", keyDefinition: "" },
        "dock-east--open-bg": { intensity: "900", keyDefinition: "" },
        /** BUTTONS */
        "button-primary": { intensity: "800", keyDefinition: "primary_button" },
        "button-primary-border": {
            intensity: "900",
            keyDefinition: "primary_button",
        },
        "button-primary--hover": {
            intensity: "700",
            keyDefinition: "primary_button_hover",
        },
        "button-secondary": { intensity: "900", keyDefinition: "secondary_button" },
        "button-secondary-border": {
            intensity: "900",
            keyDefinition: "",
        },
        "button-secondary--hover": {
            intensity: "700",
            keyDefinition: "secondary_button",
        },
        "button-secondary-text": {
            intensity: "400",
            keyDefinition: "",
        },
        "button-info": {
            intensity: "800",
            keyDefinition: "info_button",
            fixedKey: "blue",
        },
        "button-success": {
            intensity: "800",
            keyDefinition: "success_button",
            fixedKey: "green",
        },
        "button-success--hover": {
            intensity: "700",
            keyDefinition: "success_button_hover",
            fixedKey: "green",
        },
        "button-warning": {
            intensity: "800",
            keyDefinition: "warning_button",
            fixedKey: "orange",
        },
        "button-warning--hover": {
            intensity: "700",
            keyDefinition: "warning_button_hover",
            fixedKey: "orange",
        },
        "button-danger": {
            intensity: "800",
            keyDefinition: "danger_button",
            fixedKey: "red",
        },
        "button-danger--hover": {
            intensity: "700",
            keyDefinition: "danger_button_hover",
            fixedKey: "red",
        },
    },
    margin: {
        "mt-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mt",
        },
        "mr-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mr",
        },
        "mb-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mb",
        },
        "ml-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "ml",
        },
        "mt-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mt",
        },
        "mr-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mr",
        },
        "mb-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mb",
        },
        "ml-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "ml",
        },
        "mt-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mt",
        },
        "mr-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mr",
        },
        "mb-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mb",
        },
        "ml-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "ml",
        },
        "mt-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mt",
        },
        "mr-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mr",
        },
        "mb-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mb",
        },
        "ml-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "ml",
        },
        "mt-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mt",
        },
        "mr-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mr",
        },
        "mb-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mb",
        },
        "ml-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "ml",
        },
        "mt-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mt",
        },
        "mr-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mr",
        },
        "mb-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mb",
        },
        "ml-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "ml",
        },
        "mt-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mt",
        },
        "mr-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mr",
        },
        "mb-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mb",
        },
        "ml-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "ml",
        },
        "mt-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mt",
        },
        "mr-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mr",
        },
        "mb-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mb",
        },
        "ml-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "ml",
        },
        "mt-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mt",
        },
        "mr-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mr",
        },
        "mb-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mb",
        },
        "ml-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "ml",
        },
        "mt-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mt",
        },
        "mr-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mr",
        },
        "mb-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mb",
        },
        "ml-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "ml",
        },
        "mt-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mt",
        },
        "mr-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mr",
        },
        "mb-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mb",
        },
        "ml-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "ml",
        },
        "mt-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mt",
        },
        "mr-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mr",
        },
        "mb-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mb",
        },
        "ml-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "ml",
        },
        "mt-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-info-button": {
            keyDefinition: "info_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-success-button": {
            keyDefinition: "success_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mt",
        },
        "mr-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mr",
        },
        "mb-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mb",
        },
        "ml-tabs": {
            keyDefinition: "tabs",
            fixedKey: "ml",
        },
        "mt-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mt",
            defaultValue: "1.25rem",
        },
        "mr-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mr",
        },
        "mb-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mb",
            defaultValue: "1.25rem",
        },
        "ml-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "ml",
        },
        "mt-widget": {
            keyDefinition: "widget",
            fixedKey: "mt",
        },
        "mr-widget": {
            keyDefinition: "widget",
            fixedKey: "mr",
        },
        "mb-widget": {
            keyDefinition: "widget",
            fixedKey: "mb",
        },
        "ml-widget": {
            keyDefinition: "widget",
            fixedKey: "ml",
        },
        "mt-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mt",
            defaultValue: "1.25rem",
        },
        "mr-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mr",
        },
        "mb-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mb",
        },
        "ml-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "ml",
        },
    },
    padding: {
        "pt-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pt",
        },
        "pr-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pr",
        },
        "pb-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pb",
        },
        "pl-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pl",
        },
        "pt-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
    },
    border: {
        widget: {
            keyDefinition: "widget",
            fixedKey: "border",
        },
        tabs: {
            keyDefinition: "tabs",
            fixedKey: "border",
            defaultValue: borderTabsDefault,
        },
        subpanel: {
            keyDefinition: "sub_panel",
            fixedKey: "border",
            defaultValue: borderSubpanelDefault,
        },
        "subpanel-topLeft": {
            keyDefinition: "sub_panel",
            fixedKey: "topLeft",
            defaultValue: borderRadiusDefaultValues.topLeft,
        },
        "subpanel-topRight": {
            keyDefinition: "sub_panel",
            fixedKey: "topRight",
            defaultValue: borderRadiusDefaultValues.topRight,
        },
        "subpanel-bottomLeft": {
            keyDefinition: "sub_panel",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusDefaultValues.bottomLeft,
        },
        "subpanel-bottomRight": {
            keyDefinition: "sub_panel",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusDefaultValues.bottomRight,
        },
        "detail-title-topLeft": {
            keyDefinition: "detail_view_title",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "detail-title-topRight": {
            keyDefinition: "detail_view_title",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "border",
            defaultValue: borderFicheDetailsDefault,
        },
        "detail-topLeft": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "topLeft",
            defaultValue: borderRadiusBottomDefaultValues.topLeft,
        },
        "detail-topRight": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "topRight",
            defaultValue: borderRadiusBottomDefaultValues.topRight,
        },
        "detail-bottomLeft": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusBottomDefaultValues.bottomLeft,
        },
        "detail-bottomRight": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusBottomDefaultValues.bottomRight,
        },
        "tab-selected-topLeft": {
            keyDefinition: "tab_selected",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-selected-topRight": {
            keyDefinition: "tab_selected",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-selected-bottomLeft": {
            keyDefinition: "tab_selected",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-selected-bottomRight": {
            keyDefinition: "tab_selected",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "tab-topLeft": {
            keyDefinition: "tab",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-topRight": {
            keyDefinition: "tab",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-bottomLeft": {
            keyDefinition: "tab",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-bottomRight": {
            keyDefinition: "tab",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "tab-hovered-topLeft": {
            keyDefinition: "tab_hovered",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-hovered-topRight": {
            keyDefinition: "tab_hovered",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-hovered-bottomLeft": {
            keyDefinition: "tab_hovered",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-hovered-bottomRight": {
            keyDefinition: "tab_hovered",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "info-button": {
            keyDefinition: "info_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "success-button": {
            keyDefinition: "success_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
    },
    borderWidth: {
        "tab-selected": {
            keyDefinition: "tab_selected",
            fixedKey: "border_width",
            defaultValue: {
                top: "0px",
                bottom: "0px",
                left: "0px",
                right: "0px",
            },
        },
    },
    spacingElement: {
        tabs: {
            keyDefinition: "tabs",
            fixedKey: "spacing_element",
            defaultValue: {
                top: spacingDefaultValues.spacing_element_top,
                bottom: spacingDefaultValues.spacing_element_bottom,
                left: spacingDefaultValues.spacing_element_left,
                right: spacingDefaultValues.spacing_element_right,
            },
        },
    },
};
export var THEME_RUNTIME_CONFIG_COLOR_LIGHT = {
    colors: {
        /** CONTENT / TEXT */
        label: { intensity: "800", keyDefinition: "label", fixedKey: "label" },
        content: {
            intensity: "50",
            keyDefinition: "text_content",
            fixedKey: "content",
        },
        text: { intensity: "800", keyDefinition: "", fixedKey: "neutral" },
        facelift: { intensity: "50", keyDefinition: "facelift_text" },
        "facelift-circle": { intensity: "300", keyDefinition: "facelift_text" },
        subpanel: { intensity: "800", keyDefinition: "sub_panel" },
        "subpanel-bg": { intensity: "400", keyDefinition: "sub_panel" },
        tabs: { intensity: "100", keyDefinition: "tabs" },
        tab: { intensity: "600", keyDefinition: "tab" },
        "tab-selected": { intensity: "300", keyDefinition: "tab_selected" },
        "tab-hovered": { intensity: "800", keyDefinition: "tab_hovered" },
        "tab-text-survol": { intensity: "100", keyDefinition: "tab" },
        "tab-text": { intensity: "300", keyDefinition: "tab" },
        /**BORDER COLOR */
        "tab-borderColor-top": {
            intensity: "400",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_top",
        },
        "tab-borderColor-bottom": {
            intensity: "400",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_bottom",
        },
        "tab-borderColor-left": {
            intensity: "400",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_left",
        },
        "tab-borderColor-right": {
            intensity: "400",
            keyDefinition: "tab_selected",
            fixedKey: "border_color_right",
        },
        /*UNDERLINE COLOR*/
        underline: { intensity: "200", keyDefinition: "underline_color" },
        "underline-selected": {
            intensity: "500",
            keyDefinition: "underline_color",
        },
        /** HEADER / FOOTER */
        header: { intensity: "800", keyDefinition: "header" },
        "header-logo": { intensity: "800", keyDefinition: "header_logo" },
        "header-user": { intensity: "800", keyDefinition: "header_user" },
        footer: { intensity: "800", keyDefinition: "footer" },
        "footer-logo": { intensity: "800", keyDefinition: "footer_logo" },
        "footer-settings": { intensity: "800", keyDefinition: "footer_logo" },
        /** MAIN BACKGROUND */
        "main-bg": { intensity: "100", keyDefinition: "main" },
        /** WIDGETS */
        widget: { intensity: "300", keyDefinition: "widget" },
        "widget-hover": { intensity: "200", keyDefinition: "widget" },
        /** BODY */
        body: { intensity: "100", keyDefinition: "body" },
        /** MENUS – WEST */
        "menu-west": { intensity: "100", keyDefinition: "menu_west" },
        "menu-west--hover": { intensity: "100", keyDefinition: "menu_west" },
        "menu-west--open": { intensity: "100", keyDefinition: "menu_west" },
        "menu-west--hover-bg": { intensity: "300", keyDefinition: "menu_west" },
        "menu-west--open-bg": { intensity: "200", keyDefinition: "menu_west" },
        "menu-west-bg": { intensity: "200", keyDefinition: "menu_west" },
        /** MENUS – EAST */
        "menu-east": { intensity: "100", keyDefinition: "menu_east" },
        "menu-east--open": { intensity: "900", keyDefinition: "menu_east" },
        "menu-east-bg": { intensity: "200", keyDefinition: "menu_east" },
        "menu-east--hover": { intensity: "100", keyDefinition: "menu_east" },
        "menu-east--hover-bg": { intensity: "700", keyDefinition: "menu_east" },
        "menu-east--open-bg": { intensity: "800", keyDefinition: "menu_east" },
        /** MENUS – NORTH */
        "menu-north": { intensity: "100", keyDefinition: "menu_north" },
        "menu-north--hover": { intensity: "100", keyDefinition: "menu_north" },
        "menu-north--open": { intensity: "900", keyDefinition: "menu_north" },
        "menu-north-bg": { intensity: "200", keyDefinition: "menu_north" },
        "menu-north--hover-bg": { intensity: "700", keyDefinition: "menu_north" },
        "menu-north--open-bg": { intensity: "200", keyDefinition: "menu_north" },
        /** MENUS – SOUTH */
        "menu-south": { intensity: "100", keyDefinition: "menu_south" },
        "menu-south--hover": { intensity: "100", keyDefinition: "menu_south" },
        "menu-south--open": { intensity: "900", keyDefinition: "menu_south" },
        "menu-south-bg": { intensity: "200", keyDefinition: "menu_south" },
        "menu-south--hover-bg": { intensity: "700", keyDefinition: "menu_south" },
        "menu-south--open-bg": { intensity: "200", keyDefinition: "menu_south" },
        /** DOCK – NORTH */
        "dock-north": { intensity: "900", keyDefinition: "dock_north" },
        "dock-north--hover": { intensity: "800", keyDefinition: "dock_north" },
        "dock-north--open": { intensity: "900", keyDefinition: "dock_north" },
        "dock-north-bg": { intensity: "100", keyDefinition: "dock_north" },
        "dock-north--hover-bg": { intensity: "700", keyDefinition: "dock_north" },
        "dock-north--open-bg": { intensity: "100", keyDefinition: "dock_north" },
        /** DOCK – SOUTH */
        "dock-south": { intensity: "100", keyDefinition: "dock_south" },
        "dock-south--hover": { intensity: "100", keyDefinition: "dock_south" },
        "dock-south--open": { intensity: "900", keyDefinition: "dock_south" },
        "dock-south-bg": { intensity: "100", keyDefinition: "dock_south" },
        "dock-south--hover-bg": { intensity: "200", keyDefinition: "dock_south" },
        "dock-south--open-bg": { intensity: "200", keyDefinition: "dock_south" },
        /** DOCK – WEST */
        "dock-west": { intensity: "100", keyDefinition: "dock_west" },
        "dock-west--hover": { intensity: "100", keyDefinition: "dock_west" },
        "dock-west--open": { intensity: "900", keyDefinition: "dock_west" },
        "dock-west-bg": { intensity: "100", keyDefinition: "dock_west" },
        "dock-west--hover-bg": { intensity: "700", keyDefinition: "dock_west" },
        "dock-west--open-bg": { intensity: "200", keyDefinition: "dock_west" },
        /** DOCK – EAST */
        "dock-east": { intensity: "100", keyDefinition: "dock_east" },
        "dock-east--hover": { intensity: "100", keyDefinition: "dock_east" },
        "dock-east--open": { intensity: "900", keyDefinition: "dock_east" },
        "dock-east-bg": { intensity: "100", keyDefinition: "dock_east" },
        "dock-east--hover-bg": { intensity: "700", keyDefinition: "dock_east" },
        "dock-east--open-bg": { intensity: "200", keyDefinition: "dock_east" },
        /** BUTTONS */
        "button-primary": { intensity: "200", keyDefinition: "primary_button" },
        "button-primary-border": {
            intensity: "200",
            keyDefinition: "primary_button",
        },
        "button-primary--hover": {
            intensity: "300",
            keyDefinition: "primary_button_hover",
        },
        "button-secondary": { intensity: "100", keyDefinition: "secondary_button" },
        "button-secondary-border": {
            intensity: "100",
            keyDefinition: "secondary_button",
        },
        "button-secondary--hover": {
            intensity: "300",
            keyDefinition: "secondary_button",
        },
        "button-secondary-text": {
            intensity: "800",
            keyDefinition: "secondary_button",
        },
        "button-link": { intensity: "400", keyDefinition: "" },
        "button-link-border": { intensity: "450", keyDefinition: "" },
        "button-link--hover": { intensity: "500", keyDefinition: "" },
        "button-info": {
            intensity: "200",
            keyDefinition: "info_button",
            fixedKey: "blue",
        },
        "button-info-border": {
            intensity: "300",
            keyDefinition: "info_button",
            fixedKey: "blue",
        },
        "button-info--hover": {
            intensity: "300",
            keyDefinition: "info_button_hover",
            fixedKey: "blue",
        },
        "button-success": {
            intensity: "200",
            keyDefinition: "success_button",
            fixedKey: "green",
        },
        "button-success--hover": {
            intensity: "300",
            keyDefinition: "success_button_hover",
            fixedKey: "green",
        },
        "button-warning": {
            intensity: "200",
            keyDefinition: "warning_button",
            fixedKey: "orange",
        },
        "button-warning-border": {
            intensity: "300",
            keyDefinition: "warning_button",
            fixedKey: "orange",
        },
        "button-warning--hover": {
            intensity: "300",
            keyDefinition: "warning_button_hover",
            fixedKey: "orange",
        },
        "button-danger": {
            intensity: "200",
            keyDefinition: "danger_button",
            fixedKey: "red",
        },
        "button-danger-border": {
            intensity: "300",
            keyDefinition: "danger_button",
            fixedKey: "red",
        },
        "button-danger--hover": {
            intensity: "300",
            keyDefinition: "danger_button_hover",
            fixedKey: "red",
        },
    },
    margin: {
        "mt-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mt",
        },
        "mr-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mr",
        },
        "mb-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "mb",
        },
        "ml-menu-north": {
            keyDefinition: "menu_north",
            fixedKey: "ml",
        },
        "mt-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mt",
        },
        "mr-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mr",
        },
        "mb-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "mb",
        },
        "ml-menu-south": {
            keyDefinition: "menu_south",
            fixedKey: "ml",
        },
        "mt-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mt",
        },
        "mr-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mr",
        },
        "mb-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "mb",
        },
        "ml-menu-east": {
            keyDefinition: "menu_east",
            fixedKey: "ml",
        },
        "mt-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mt",
        },
        "mr-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mr",
        },
        "mb-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "mb",
        },
        "ml-menu-west": {
            keyDefinition: "menu_west",
            fixedKey: "ml",
        },
        "mt-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mt",
        },
        "mr-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mr",
        },
        "mb-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "mb",
        },
        "ml-dock-north": {
            keyDefinition: "dock_north",
            fixedKey: "ml",
        },
        "mt-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mt",
        },
        "mr-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mr",
        },
        "mb-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "mb",
        },
        "ml-dock-south": {
            keyDefinition: "dock_south",
            fixedKey: "ml",
        },
        "mt-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mt",
        },
        "mr-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mr",
        },
        "mb-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "mb",
        },
        "ml-dock-east": {
            keyDefinition: "dock_east",
            fixedKey: "ml",
        },
        "mt-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mt",
        },
        "mr-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mr",
        },
        "mb-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "mb",
        },
        "ml-dock-west": {
            keyDefinition: "dock_west",
            fixedKey: "ml",
        },
        "mt-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mt",
        },
        "mr-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mr",
        },
        "mb-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "mb",
        },
        "ml-drawer-north": {
            keyDefinition: "drawer_north",
            fixedKey: "ml",
        },
        "mt-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mt",
        },
        "mr-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mr",
        },
        "mb-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "mb",
        },
        "ml-drawer-south": {
            keyDefinition: "drawer_south",
            fixedKey: "ml",
        },
        "mt-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mt",
        },
        "mr-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mr",
        },
        "mb-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "mb",
        },
        "ml-drawer-east": {
            keyDefinition: "drawer_east",
            fixedKey: "ml",
        },
        "mt-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mt",
        },
        "mr-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mr",
        },
        "mb-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "mb",
        },
        "ml-drawer-west": {
            keyDefinition: "drawer_west",
            fixedKey: "ml",
        },
        "mt-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-info-button": {
            keyDefinition: "info_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-info-button": {
            keyDefinition: "info_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-success-button": {
            keyDefinition: "success_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-success-button": {
            keyDefinition: "success_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mt",
            defaultValue: defaultValues["mt"],
        },
        "mr-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mr",
            defaultValue: defaultValues["mr"],
        },
        "mb-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "mb",
            defaultValue: defaultValues["mb"],
        },
        "ml-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "ml",
            defaultValue: defaultValues["ml"],
        },
        "mt-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mt",
        },
        "mr-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mr",
        },
        "mb-tabs": {
            keyDefinition: "tabs",
            fixedKey: "mb",
        },
        "ml-tabs": {
            keyDefinition: "tabs",
            fixedKey: "ml",
        },
        "mt-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mt",
            defaultValue: "1.25rem",
        },
        "mr-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mr",
        },
        "mb-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "mb",
            defaultValue: "1.25rem",
        },
        "ml-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "ml",
        },
        "mt-widget": {
            keyDefinition: "widget",
            fixedKey: "mt",
        },
        "mr-widget": {
            keyDefinition: "widget",
            fixedKey: "mr",
        },
        "mb-widget": {
            keyDefinition: "widget",
            fixedKey: "mb",
        },
        "ml-widget": {
            keyDefinition: "widget",
            fixedKey: "ml",
        },
        "mt-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mt",
            defaultValue: "1.25rem",
        },
        "mr-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mr",
        },
        "mb-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "mb",
        },
        "ml-detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "ml",
        },
    },
    padding: {
        "pt-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pt",
        },
        "pr-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pr",
        },
        "pb-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pb",
        },
        "pl-subpanel": {
            keyDefinition: "sub_panel",
            fixedKey: "pl",
        },
        "pt-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-info-button": {
            keyDefinition: "info_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-success-button": {
            keyDefinition: "success_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
        "pt-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pt",
            defaultValue: defaultValues["pt"],
        },
        "pr-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pr",
            defaultValue: defaultValues["pr"],
        },
        "pb-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pb",
            defaultValue: defaultValues["pb"],
        },
        "pl-danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "pl",
            defaultValue: defaultValues["pl"],
        },
    },
    border: {
        widget: {
            keyDefinition: "widget",
            fixedKey: "border",
        },
        tabs: {
            keyDefinition: "tabs",
            fixedKey: "border",
            defaultValue: borderTabsDefault,
        },
        subpanel: {
            keyDefinition: "sub_panel",
            fixedKey: "border",
            defaultValue: borderSubpanelDefault,
        },
        "subpanel-topLeft": {
            keyDefinition: "sub_panel",
            fixedKey: "topLeft",
            defaultValue: borderRadiusDefaultValues.topLeft,
        },
        "subpanel-topRight": {
            keyDefinition: "sub_panel",
            fixedKey: "topRight",
            defaultValue: borderRadiusDefaultValues.topRight,
        },
        "subpanel-bottomLeft": {
            keyDefinition: "sub_panel",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusDefaultValues.bottomLeft,
        },
        "subpanel-bottomRight": {
            keyDefinition: "sub_panel",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusDefaultValues.bottomRight,
        },
        "detail-title-topLeft": {
            keyDefinition: "detail_view_title",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "detail-title-topRight": {
            keyDefinition: "detail_view_title",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "detail-view-fiche": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "border",
            defaultValue: borderFicheDetailsDefault,
        },
        "detail-topLeft": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "topLeft",
            defaultValue: borderRadiusBottomDefaultValues.topLeft,
        },
        "detail-topRight": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "topRight",
            defaultValue: borderRadiusBottomDefaultValues.topRight,
        },
        "detail-bottomLeft": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusBottomDefaultValues.bottomLeft,
        },
        "detail-bottomRight": {
            keyDefinition: "detail_view_fiche",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusBottomDefaultValues.bottomRight,
        },
        "tab-selected-topLeft": {
            keyDefinition: "tab_selected",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-selected-topRight": {
            keyDefinition: "tab_selected",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-selected-bottomLeft": {
            keyDefinition: "tab_selected",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-selected-bottomRight": {
            keyDefinition: "tab_selected",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "tab-topLeft": {
            keyDefinition: "tab",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-topRight": {
            keyDefinition: "tab",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-bottomLeft": {
            keyDefinition: "tab",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-bottomRight": {
            keyDefinition: "tab",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "tab-hovered-topLeft": {
            keyDefinition: "tab_hovered",
            fixedKey: "topLeft",
            defaultValue: borderRadiusTopDefaultValues.topLeft,
        },
        "tab-hovered-topRight": {
            keyDefinition: "tab_hovered",
            fixedKey: "topRight",
            defaultValue: borderRadiusTopDefaultValues.topRight,
        },
        "tab-hovered-bottomLeft": {
            keyDefinition: "tab_hovered",
            fixedKey: "bottomLeft",
            defaultValue: borderRadiusTopDefaultValues.bottomLeft,
        },
        "tab-hovered-bottomRight": {
            keyDefinition: "tab_hovered",
            fixedKey: "bottomRight",
            defaultValue: borderRadiusTopDefaultValues.bottomRight,
        },
        "primary-button": {
            keyDefinition: "primary_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "secondary-button": {
            keyDefinition: "secondary_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "info-button": {
            keyDefinition: "info_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "success-button": {
            keyDefinition: "success_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "warning-button": {
            keyDefinition: "warning_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
        "danger-button": {
            keyDefinition: "danger_button",
            fixedKey: "border",
            defaultValue: borderButtonDefault,
        },
    },
    borderWidth: {
        "tab-selected": {
            keyDefinition: "tab_selected",
            fixedKey: "border_width",
            defaultValue: {
                top: "0px",
                bottom: "0px",
                left: "0px",
                right: "0px",
            },
        },
    },
    spacingElement: {
        tabs: {
            keyDefinition: "tabs",
            fixedKey: "spacing_element",
            defaultValue: {
                top: spacingDefaultValues.spacing_element_top,
                bottom: spacingDefaultValues.spacing_element_bottom,
                left: spacingDefaultValues.spacing_element_left,
                right: spacingDefaultValues.spacing_element_right,
            },
        },
    },
};
export function createVariableByTheme(themeColor, underlineColor, fontOpacity, themeConfig, paletteColors) {
    var _a;
    if (paletteColors === void 0) { paletteColors = []; }
    if (!themeConfig)
        return {};
    var cssVars = {};
    /* ========= COLORS ========= */
    Object.entries((_a = themeConfig.colors) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
        var _b, _c;
        var key = _a[0], _d = _a[1], intensity = _d.intensity, keyDefinition = _d.keyDefinition, fixedKey = _d.fixedKey;
        var opacity = keyDefinition && ((_b = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity[keyDefinition]) === null || _b === void 0 ? void 0 : _b.opacity) != null
            ? fontOpacity[keyDefinition].opacity / 100
            : 1;
        var colorKey = themeColor;
        if (!(keyDefinition === null || keyDefinition === void 0 ? void 0 : keyDefinition.startsWith("tabs"))) {
            colorKey = fixedKey !== null && fixedKey !== void 0 ? fixedKey : themeColor;
        }
        // Cas spécial underline
        if (keyDefinition === "underline_color") {
            colorKey = underlineColor;
        }
        if (keyDefinition === "tab_selected" &&
            (fixedKey === null || fixedKey === void 0 ? void 0 : fixedKey.startsWith("border_color"))) {
            //const borderValue = fontOpacity?.tabs?.[fixedKey];
            var borderValue = (_c = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity[keyDefinition]) === null || _c === void 0 ? void 0 : _c[fixedKey];
            var borderColorKey = themeColor || "blue";
            if ((borderValue === null || borderValue === void 0 ? void 0 : borderValue.source) === "palette") {
                cssVars["--colors-".concat(key)] =
                    paletteColors[borderValue.value] || "blue";
            }
            else {
                // source base OU undefined
                cssVars["--colors-".concat(key)] = "rgb(var(--color-".concat(borderColorKey, "-").concat(intensity, ") / 1)");
            }
            return;
        }
        cssVars["--colors-".concat(key)] = "rgb(var(--color-".concat(colorKey, "-").concat(intensity, ") / ").concat(opacity, ")");
    });
    /* ========= SPACING ========= */
    var applySpacing = function (type, config) {
        Object.entries(config !== null && config !== void 0 ? config : {}).forEach(function (_a) {
            var _b, _c, _d;
            var key = _a[0], _e = _a[1], keyDefinition = _e.keyDefinition, fixedKey = _e.fixedKey, defaultValue = _e.defaultValue;
            var value = (_d = (_c = (_b = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity[keyDefinition]) === null || _b === void 0 ? void 0 : _b[fixedKey]) !== null && _c !== void 0 ? _c : defaultValue) !== null && _d !== void 0 ? _d : "0px";
            cssVars["--".concat(type, "-").concat(key)] = value;
        });
    };
    /* ========= BORDER WIDTH ========= */
    var applyBorderWidth = function (config) {
        Object.entries(config !== null && config !== void 0 ? config : {}).forEach(function (_a) {
            var key = _a[0], _b = _a[1], keyDefinition = _b.keyDefinition, defaultValue = _b.defaultValue;
            var settings = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity[keyDefinition];
            var sides = ["top", "bottom", "left", "right"];
            sides.forEach(function (side) {
                var _a, _b;
                var value = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings["border_width_".concat(side)]) !== null && _a !== void 0 ? _a : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[side]) !== null && _b !== void 0 ? _b : "4px";
                cssVars["--border-width-".concat(key, "-").concat(side)] = value;
            });
        });
    };
    var applySpacingElement = function (config) {
        Object.entries(config !== null && config !== void 0 ? config : {}).forEach(function (_a) {
            var key = _a[0], _b = _a[1], keyDefinition = _b.keyDefinition, defaultValue = _b.defaultValue;
            var settings = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity[keyDefinition];
            var sides = ["top", "bottom", "left", "right"];
            sides.forEach(function (side) {
                var _a, _b;
                var value = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings["spacing_element_".concat(side)]) !== null && _a !== void 0 ? _a : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[side]) !== null && _b !== void 0 ? _b : "4px";
                cssVars["--spacing-element-".concat(key, "-").concat(side)] = value;
            });
        });
    };
    applySpacing("margin", themeConfig.margin);
    applySpacing("padding", themeConfig.padding);
    applySpacing("border", themeConfig.border);
    applyBorderWidth(themeConfig.borderWidth);
    applySpacingElement(themeConfig.spacingElement);
    console.log("CSS VAR ", cssVars);
    return cssVars;
}
/**Function utils for base64 bgImage */
export var cleanBase64 = function (base64String) {
    return base64String && (base64String === null || base64String === void 0 ? void 0 : base64String.includes("base64,"))
        ? base64String.split("base64,")[1]
        : base64String;
};
export var loadBGImage = function (image, outPut) {
    var output = cleanBase64(outPut);
    if ((image === null || image === void 0 ? void 0 : image.type) === "image") {
        var imageData = "data:image/jpeg;base64," + output;
        document.documentElement.style.setProperty("--dynamic-background", "url(".concat(imageData, ")"));
    }
    else if ((image === null || image === void 0 ? void 0 : image.type) === "url") {
        document.documentElement.style.setProperty("--dynamic-background", "url(".concat(image === null || image === void 0 ? void 0 : image.image, ")"));
    }
};
export var translateLabel = function (label, t, module) {
    var moduleTranslation = t(label, { ns: module });
    var finalLabel = moduleTranslation === label ? t("app.".concat(label)) : moduleTranslation;
    return finalLabel.replace(/:/g, "");
};
